import React from 'react';
import './Footer.css';

export default function Footer() {
    return(
        <React.Fragment>
            <footer>
                <p>Made with <span className="one">♥</span> by <a href="https://suryapratap.netlify.app/">Suryapratap Singh</a> in <span className="two">India</span></p>
            </footer>
        </React.Fragment>
    );
}